<template>
  <div class="flash">
    <div v-for="goodsInfo in goodsInfoLsit" class="goods-card"
         @click="$router.push({path:'/flash',query:{goodId:goodsInfo.id}})">
      <div class="top">
        <img :src="goodsInfo.cover"/>
      </div>
      <div class="bottom">
        <div class="name">{{ goodsInfo.goodsName }}</div>
        <div class="info">
          <span class="price">￥{{ goodsInfo.price }}</span>
          <span class="spec">规格：{{ goodsInfo.specStr }}</span>
        </div>
        <div class="btns">
          <!-- <div class="btn grey" v-if="!isTimeOver">
                        <van-count-down :time="countDownTime" format="HH 时 mm 分 ss 秒" @finish="onCountDownFinish" :auto-start="isStart" />
                    </div> -->
          <div class="btn">立即抢购</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getGoodsInfo, getStartTime, getSecOrderInfo, getGoodsInfoList} from "@/api/home";
import {finishTask} from "@/api/task";

export default {

  data() {
    return {
      goodsInfoLsit: [],
      isTimeOver: false,
      isEmpty: false,
      isPayed: false,
      isFinish: false,

      isGet: false,

      countDownTime: 86399000,
      isStart: false
    };
  },

  methods: {

    async finishTask() {
      console.log(this.$store.state.userInfo);
      const {data: res} = await finishTask({
        m2oId: this.$store.state.nthUserInfo.userid
      });
      if (res.code == 200) {
        if (res.data) {
          SmartCity.creditRulesUpdate({
            availableScore: res.data.availableScore
          });
          this.$toast(res.data.message);
        }

        // this.getFavoriteServeList()
      }
    },
    onCountDownFinish() {
      this.isTimeOver = true;
    },
    async getGoodsInfoList() {
      const {data: res} = await getGoodsInfoList()
      if (res.code === 200) {
        this.goodsInfoLsit = [...res.data]
        console.log(res,"双实体")
      }
    },
    async getGoodsInfo() {
      const {data: res} = await getGoodsInfo();
      if (res.code == 200) {
        this.goodsInfoLsit = [{...res.data}];
        console.log(res, "单实体")
      }
    },

    async getStartTime() {
      const {data: res} = await getStartTime();
      if (res.code == 200) {
        let date = res.data.replace(/-/g, "/");
        // let date = '2022-04-30 20:00:00'.replace(/-/g, "/");
        this.countDownTime = Date.parse(new Date(date)) - new Date().getTime();
        this.isStart = true;
      }
    },


    async getSecOrderInfo() {
      const {data: res} = await getSecOrderInfo({
        m2oId: this.$store.state.nthUserInfo.userid
      });

      // console.log("首次查询订单", res);
      // if (res.code == 200) {
      //     this.isGet = true;
      // } else {
      //     if (res.code == 200100) {
      //         this.isEmpty = true;
      //     }

      //     if (res.code == 200005) {
      //         this.isPayed = true;
      //     }

      //     if (res.code == 200102) {
      //         this.isFinish = true;
      //     }
      // }
    }
  },

  created() {
    // this.getGoodsInfo();
    this.getStartTime();
    this.$skillType === 3 ? this.getGoodsInfoList() : this.getGoodsInfo()
    SmartCity.getUserInfo((res) => {
      if (res && res.userInfo) {
        this.$store.commit("setNthUserInfo", res.userInfo);
        this.$store.commit("setUserTokenKey", res.userInfo.userTokenKey);
        this.finishTask();

        // this.getSecOrderInfo();
      }
    });
  }
};
</script>

<style lang="less" scoped>
.flash {
  width: 100%;
  // margin-top: 10px;
  position: relative;
  // margin: 10px;
}
</style>
